// extracted by mini-css-extract-plugin
export default {"secondaryIdGroup":"rUmged4oAoQFdl_KPJN6"};